export default [
  /* AUTHENTICATION ROUTES */
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/pages/authentication/Register.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/register/invited/:token',
    name: 'auth-register-invite',
    component: () => import('@/views/pages/authentication/RegisterInvite.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/reset-password',
    name: 'auth-reset-password',
    component: () => import('@/views/pages/authentication/ResetPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/verification',
    name: 'auth-verify-account',
    component: () => import('@/views/pages/authentication/VerifyAccount.vue'),
    meta: {
      layout: 'full',
      resource: 'Misc',
      // redirectIfLoggedIn: true,
    },
  },

  /* PAGES ROUTES */
  {
    path: '/privacy',
    name: 'privacy-policy',
    component: () => import('@/views/pages/miscellaneous/PrivacyPolicy.vue'),
    meta: {
      layout: 'full',
      resource: 'Misc',
      action: 'read',
    },
  },
  {
    path: '/tos',
    name: 'terms',
    component: () => import('@/views/pages/miscellaneous/Terms.vue'),
    meta: {
      layout: 'full',
      resource: 'Misc',
      action: 'read',
    },
  },

  /* ERROR ROUTES */
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Misc',
      action: 'read',
    },
  },
  {
    path: '/coming-soon',
    name: 'misc-coming-soon',
    component: () => import('@/views/pages/miscellaneous/ComingSoon.vue'),
    meta: {
      layout: 'full',
      resource: 'Misc',
      action: 'read',
    },
  },
  {
    path: '/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'Misc',
      action: 'read',
    },
  },
  {
    path: '/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import('@/views/pages/miscellaneous/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
      resource: 'Misc',
      action: 'read',
    },
  },
  {
    path: '/error',
    name: 'misc-error',
    component: () => import('@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
      resource: 'Misc',
      action: 'read',
    },
  },
]
